<template>
  <div class="addon-section">
    <div class="ly--outer--container relative bg__addonSection">
      <ImageWrapper
        src="/assets/images/addon_bg.png"
        alt=""
        class="addon-section__bg"
      />
      <ImageWrapper
        src="/assets/images/addon_bg_mobile.png"
        alt=""
        class="addon-section__bg--mobile"
      />
      <div class="ly--content--container relative">
        <ImageWrapper
          src="/assets/images/addon_flower1.png"
          alt=""
          class="addon-section__flower1"
        />
        <ImageWrapper
          src="/assets/images/addon_flower2.png"
          alt=""
          class="addon-section__flower2"
        />
        <div class="addon-section__container">
          <!-- Section Header -->
          <div class="addon-section__header">
            <!-- <h2 class="addon-section__title col__white fz-40 fw-bold text-center">
          {{ $t("addonSection.title") }}
        </h2> -->

            <TitleSection class="mB0">
              <div v-html="$t('addonSection.title')"></div>
            </TitleSection>
          </div>

          <!-- Products Carousel -->
          <div class="addon-section__products">
            <div class="addon-swiper-nav prev">
              <ImageWrapper src="/assets/images/arrow.png" alt="" />
            </div>
            <div class="carousel-wrapper">
              <swiper
                ref="addonSwiper"
                :options="swiperOptions"
                class="products-carousel"
              >
                <swiper-slide
                  v-for="(product, index) in addonProducts"
                  :key="product.sku + '' + index"
                  class="carousel-slide"
                >
                  <div class="product-card-container">
                    <div
                      class="product-card"
                      v-vue-aos.once="{
                        animationClass: 'animate__animated animate__fadeIn',
                      }"
                    >
                      <div class="product-content">
                        <div
                          class="product-content__inner addon-product__content"
                        >
                          <div
                            class="addon-product__image-wrapper"
                            v-vue-aos.once="{
                              animationClass:
                                'animate__animated animate__fadeInDown',
                            }"
                          >
                            <ImageWrapper
                              :src="product.image"
                              :alt="product.name"
                              class="addon-product__image"
                            />
                          </div>
                          <div class="addon-product__text-content">
                            <h3 class="addon-product__name">
                              {{ product.name }}
                            </h3>
                          </div>

                          <div class="col__black">
                            <div class="addon-product__pricing">
                              <div
                                class="addon-product__price col__black fw-bold"
                              >
                                {{ product.price }}
                              </div>

                              <div class="addon-product__price-details">
                                <span
                                  class="addon-product__original-price col__black fw-light"
                                >
                                  {{ product.originalPrice }}
                                </span>
                                <span
                                  class="addon-product__discount bg__discount col__white fw-bold"
                                >
                                  {{ product.discount }}
                                </span>
                              </div>
                            </div>

                            <AddToCart
                              :id="product.sku"
                              size="small"
                              class="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="addon-swiper-nav next">
              <ImageWrapper src="/assets/images/arrow.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSection from "../molecules/TitleSection.vue";
import { AddToCart, ImageWrapper } from "~/components/";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "AddonSection",

  components: {
    AddToCart,
    TitleSection,
    ImageWrapper,
    Swiper,
    SwiperSlide,
  },

  data() {
    return {
      swiperOptions: {
        slidesPerView: 4.5,
        spaceBetween: 24,
        navigation: {
          nextEl: ".addon-swiper-nav.next",
          prevEl: ".addon-swiper-nav.prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 3.5,
            spaceBetween: 16,
          },
          920: {
            slidesPerView: 4.5,
            spaceBetween: 16,
          },
          1100: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
      },
    };
  },

  /**
   * Computed properties for reactive data
   */
  computed: {
    /**
     * Get addon products from translation data
     * @returns {Array} Array of addon product objects
     */
    addonProducts() {
      return this.$t("addonSection.data") || [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.swiper-slide {
  height: unset;
}

.addon-section__container {
  padding-top: rem(103);
  padding-bottom: rem(152);

  display: flex;
  flex-direction: column;
  gap: rem(30);

  position: relative;
  z-index: 2;
}
.addon-section__bg {
  position: absolute;
  width: 100%;
  height: 1067px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;

  @include media-breakpoint-down(lg) {
    display: none;
  }
}

.addon-section__bg--mobile {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;

  display: none;
  @include media-breakpoint-down(lg) {
    display: block;
  }
}

.addon-section {
  padding: rem(80) 0;
  position: relative;
  overflow: hidden;
  margin-top: -185px;
  z-index: 1;
  padding-bottom: 0;

  .addon-section__flower1 {
    position: absolute;
    width: rem(79);
    height: auto;
    top: 107px;
    left: 2%;

    @include media-breakpoint-down(md) {
      width: rem(32);
    }
  }
  .addon-section__flower2 {
    position: absolute;
    width: rem(311);
    height: auto;
    top: 36px;
    right: 3%;

    @include media-breakpoint-down(md) {
      width: 7.75rem;
      right: 20px;
      top: 72px;
    }
  }

  .product-card-container {
    &::before {
      content: "";
      aspect-ratio: 19 / 10;
      display: block;
      flex: 0;
      width: 100%;
    }

    height: 100%;
    display: flex;
    width: 100%;
    flex-direction: column;

    @include media-breakpoint-down(md) {
      padding-top: 4rem;
    }

    .product-card {
      overflow: visible;
      padding-top: 1px;
      padding-bottom: 1px;
      // margin-top: rem(160);
      height: 100%;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - rem(26));
        height: calc(100% - rem(26));
        border: 2px solid #bf936c;
        border-radius: 1.25rem;
      }

      .product-content {
        position: relative;
        padding: 0;
        margin: 0;
        padding: rem(24);
        border: none;
      }
    }
  }

  .product-card-container .product-card .product-content__inner {
    text-align: center;
    align-items: center;
  }

  // &__container {
  //   position: relative;
  //   z-index: 2;
  // }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: rem(12);

    @include media-breakpoint-down(md) {
      margin-top: 2.25rem;
    }
  }

  &__title {
    text-transform: uppercase;
    letter-spacing: rem(4);
    line-height: 1.2;
  }

  &__divider {
    width: rem(40);
    height: rem(3);
    background-color: color(accent);
    border-radius: rem(2);
  }

  &__products {
    width: 100%;
    // overflow: auto;

    @include media-breakpoint-down(lg) {
      overflow: unset;
    }

    .row {
      flex-wrap: nowrap;
      justify-content: flex-start;
      @include media-breakpoint-down(lg) {
        flex-wrap: wrap;
        --bs-gutter-x: 12px;
      }
    }
  }
}

.addon-product {
  &__card {
    padding: rem(24) rem(40);
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease;

    // &:hover {
    //   transform: translateY(rem(-5));
    //   box-shadow: 0 rem(10) rem(30) rgba(0, 0, 0, 0.1);
    // }
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: rem(24);
    text-align: center;
  }

  &__image {
    position: absolute;
    // width: calc(100% + rem(48));
    width: 115%;
    height: auto;
    aspect-ratio: 1 / 1;
    left: 50%;
    transform: translateX(-50%);
    bottom: rem(-38);

    @include media-breakpoint-down(md) {
      bottom: -1.6rem;
    }
  }

  &__image-wrapper {
    width: 100%;
    // height: rem(63);
    overflow: visible;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 1.25rem;
    aspect-ratio: 16 / 2;
  }

  // &__image {
  //   max-width: 100%;
  //   max-height: 100%;
  //   object-fit: contain;
  // }

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: rem(24);
  }

  &__text-content {
    display: flex;
    flex-direction: column;
    gap: rem(8);
    text-align: center;
    align-items: center;
  }

  &__name {
    text-transform: uppercase;
    letter-spacing: rem(2.4);
    line-height: 1.2;
    // font-size: rem(20);
    font-size: rem(19);
    font-weight: bold;
    color: color(black);
    min-height: 2.5em;
    display: flex;
    align-items: flex-end;

    @include media-breakpoint-down(md) {
      font-size: rem(14);
      letter-spacing: unset;
      min-height: unset;
    }
  }

  &__pricing {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: rem(4);
  }

  &__price {
    line-height: 1;

    @include media-breakpoint-down(md) {
      font-size: rem(32) !important;
    }
  }

  &__price-details {
    display: flex;
    align-items: center;
    gap: rem(8);
    @include media-breakpoint-down(md) {
      flex-direction: column;
    }
  }

  &__price-detail {
    @include media-breakpoint-down(md) {
      font-size: rem(14) !important;
    }
  }

  &__original-price {
    text-decoration: line-through;
    text-decoration-skip-ink: none;
    text-underline-position: from-font;
    line-height: 1;
  }

  &__discount {
    padding: rem(2) rem(8);
    height: rem(28);
    white-space: nowrap;
    letter-spacing: rem(1.6);
    display: flex;
    align-items: center;

    @include media-breakpoint-down(md) {
      font-size: rem(14);
      height: rem(17);
    }
  }
}

.product {
  &-card {
    display: flex;
    flex-direction: column;
  }
  &-content {
    flex: 1;

    .addon-product__content {
      height: 100%;
    }

    .col__black {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
      gap: rem(24);
    }
  }
}

// Responsive adjustments
/*

@include media-breakpoint-down(lg) {
  .addon-section {
    padding: rem(60) 0;

    &__header {
      margin-bottom: rem(0);
    }

    &__title {
      font-size: rem(32);
    }
  }

  .addon-product {
    &__card {
      padding: rem(20) rem(30);
    }

    &__image-wrapper {
      height: rem(160);
      margin-bottom: rem(20);
    }

    &__name {
      font-size: rem(20);
    }

    &__price {
      font-size: rem(32);
    }

    &__original-price {
      font-size: rem(20);
    }
  }
}

*/

.addon-product {
  &__price {
    font-size: rem(32);
  }
  &__original-price {
    font-size: rem(16);
  }

  &__discount {
    font-size: 12px;
    padding: 5px;
    height: unset;
  }
}
@include media-breakpoint-down(md) {
  .addon-section {
    padding: rem(40) 0;

    &__title {
      font-size: rem(28);
      letter-spacing: rem(2);
    }
  }

  .addon-product {
    &__card {
      padding: rem(16) rem(24);
    }

    &__image-wrapper {
      height: 0;
    }

    &__price {
      font-size: rem(28);
    }

    &__original-price {
      font-size: rem(14);
    }
  }
}

.addon-section .carousel-wrapper {
  position: relative;
}

.addon-section .addon-swiper-nav {
  display: none !important;
  width: rem(52);
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--Color, #bf936c);
  border-radius: 100%;
  cursor: pointer;

  position: absolute;
  top: 50%;
  z-index: 3;
}

.addon-section .addon-swiper-nav.prev {
  left: 0;
  transform: translateY(-50%);
}

.addon-section .addon-swiper-nav.next {
  right: 0;
  transform: translateY(-50%);
}

.addon-section .addon-swiper-nav img {
  width: rem(12);
  height: auto;
}

.addon-section .addon-swiper-nav.next img {
  transform: rotate(180deg);
}

.addon-section .carousel-wrapper .swiper-container {
  // overflow: visible;
}
</style>
